<template>
  <v-card>
    <!-- Navigation bar -->
    <v-app-bar app color="transparent" flat>
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndUp" class="pr-0" color="white" @click.stop="toggleleftMenu"></v-app-bar-nav-icon>
      <v-icon v-else class="pr-0" color="white" @click.stop="toggleleftMenu">mdi-arrow-right</v-icon>
      <!---
        This button will be used in the future for mobile viewing
      <v-btn color="transparent">
        <v-icon color="white">mdi-magnify</v-icon>
      </v-btn>
      ----->
      <!--Desktop search bar-->
      <v-responsive v-if="$vuetify.breakpoint.mdAndUp" class="mx-auto mr-0 pt-2" max-width="27%" color="black">
        <v-toolbar dense rounded color="ECEFF1"
        >
          <v-autocomplete label="Search the Globe..." style="margin-top: 30px; position: relative; z-index: 1200;" :items="countries" dense rounded
            solo clearable autofocus item-text='name' return-object @input="getCountry"
            @blur="search = null"
            v-model="search"
            >
          </v-autocomplete>
        </v-toolbar>
      </v-responsive>
      <!--Mobile search bar-->
      <v-responsive v-else class="mx-auto" color="white" style="position: relative; z-index: 1200;">
        <v-expand-x-transition>
        <v-autocomplete
            v-if="searchActive"
            @blur="searchActive = false && null"
            v-model="search"
            v-click-outside="() => searchActive = false"
            :items="countries"
            dense
            rounded
            autofocus
            clearable
            hide-details
            solo
            item-text="name"
            return-object
            @input="getCountry"
            prepend-inner-icon="mdi-magnify"
          />
          <v-btn
            v-else
            icon
            class="pr-0 mr-0"
            color="white"
            @click="searchActive = true"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          </v-expand-x-transition>

      </v-responsive>
      <!--  Beginning of message icon and dialog box  -->
      <div class="d-flex justify-space-around" style="position: relative; z-index: 1200;">
        <v-menu v-model="message"  class="pt-9" transition="scale-transition">
          <template v-slot:activator="{ on, props }">
            <v-btn icon v-on="on" v-bind="props" min-width="0" class="pl-0" color="transparent">
              <v-badge color="blue" overlap bordered dot>
                <v-icon class="px-0" :color="message ? 'yellow lighten-1' : 'white'">mdi-message</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <div class="pt-9">
            <v-list>
              <v-list-item v-for="chat in recent" :key="chat.title">
                <v-btn class="body-2 pl-0" elevation color="transparent" @click="showChat">
                  <v-badge
                    bordered
                    bottom
                    color="blue accent-4"
                    dot
                    offset-x="10"
                    offset-y="10">
                    <v-avatar size="30">
                      <v-img :alt="`${chat.title} avatar`" :src="chat.avatar"></v-img>
                    </v-avatar>
                  </v-badge>
                  <v-list-item-content class="pl-1">
                    <v-list-item-title class="text-caption" v-text="chat.title"></v-list-item-title>
                  </v-list-item-content>
                </v-btn>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list class="pb-0 pt-0">
              <v-subheader class="text-caption">Previous chats</v-subheader>
                <v-list-item v-for="chat in previous" :key="chat.title">
                  <v-btn class="body-2 pl-1" elevation color="transparent" @click="showChat">
                    <v-badge  
                      bordered
                      bottom
                      color="red accent-4"
                      dot
                      offset-x="10"
                      offset-y="10">
                      <v-avatar size="30">
                        <v-img :alt="`${chat.title} avatar`" :src="chat.avatar"></v-img>
                      </v-avatar>
                    </v-badge>
                      <v-list-item-content class="pl-1">
                        <v-list-item-title class="text-caption" v-text="chat.title"></v-list-item-title>
                      </v-list-item-content>
                  </v-btn>
                </v-list-item>
            </v-list>
          </div>
        </v-menu>
      </div>
      <v-menu v-model="calendar" style="position: relative; z-index: 1200;"  class="pt-9 pr-9" transition="scale-transition">
        <template v-slot:activator="{ on, props }">
          <v-btn v-on="on" v-bind="props" min-width="0" color="transparent" class="pa-0 coming-soon-btn">
            <v-badge color="blue" overlap bordered dot>
              <v-icon class="px-0" :color="calendar ? 'yellow lighten-1' : 'white'">mdi-calendar-month</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <div class="pt-9">
          <v-date-picker color="primary" v-model="date1" :events="arrayEvents" event-color="green lighten-1" />
        </div>
      </v-menu>
      <v-menu style="position: relative; z-index: 1200;" v-model="newspaper"  elevation="0" class="pt-9" transition="slide-x-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" min-width="0" color="transparent" icon dark @click="triggerTrendingNews()">
            <v-icon class="px-2" :color="newspaper ? 'yellow lighten-1' : 'white'">mdi-newspaper-variant</v-icon>
          </v-btn>
        </template>
        <v-list style="flex:1; overflow-y:auto; max-height:100vh;" 
          class="pt-0" color="transparent" width="450px" height="465px">
          <trendingNews :trendingNews="trendingNews" />
        </v-list>
      </v-menu>
      <v-menu v-model="bell" style="position: relative; z-index: 1200;"  class="pt-9 pr-9" transition="slide-x-transition">
        <template v-slot:activator="{ on, props }">
          <v-btn v-on="on" v-bind="props" color="transparent" min-width="0" class="pa-0" @click="togglePastLives">
            <v-badge disabled color="blue" content="1" overlap dot bordered>
              <v-icon :color="bell ? 'yellow lighten-1' : 'white'">mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <div class="pt-9">
          <pastLives />
        </div>
      </v-menu>
      <v-menu v-model="earth" style="position: relative; z-index: 1200;"  transition="slide-x-transition">
        <template v-slot:activator="{ on, props }">
          <v-btn v-on="on" v-bind="props" color="transparent" class="pa-0">
            <v-badge color="blue" overlap bordered dot>
              <v-icon :color="earth ? 'yellow lighten-1' : 'white'">mdi-earth</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-list class="pt-9" color="transparent" width="460px" height="160px">
          <observationPost />
        </v-list>
      </v-menu>
      
      <!-- <trendingNews :t rendingNews="trendingNews"/> -->
       <!--
      <v-dialog v-model="showProgressBar" persistent width="110">
        <div v-show="showProgressBar" class="text-center">
          <v-progress-circular :rotate="-90" :size="80" :width="15" :value="progressBarValue" color="primary">
            <v-list-item-avatar class="mx-0">
              <v-img :src="profile_image"></v-img>
            </v-list-item-avatar>
          </v-progress-circular>
        </div>
      </v-dialog>
      -->
      <v-btn color="transparent" class="pl-0 pr-0" @click="openMyProfile">
        <v-list-item-group class="pr-0">
          <v-list-item-avatar size="45" class="v-img">
            <v-img :src="profile_image"></v-img>
          </v-list-item-avatar>
        </v-list-item-group>
      </v-btn>
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndUp" color="white" @click.stop="toggleRightMenu"></v-app-bar-nav-icon>
      <v-icon v-else color="white" @click.stop="toggleRightMenu">mdi-arrow-left</v-icon>
    </v-app-bar>
    <leftMenu v-if="openLeftDrawer"
      v-model="openLeftDrawer"
      :isMobile="isMobile"
    />
    <rightMenu v-if="openRightDrawer"
      v-model="openRightDrawer"
      :isMobile="isMobile"
    />
  </v-card>
</template>

<script>
import axios from 'axios'
import { ClickOutside } from 'vuetify/lib/directives'
import { mapMutations } from 'vuex'
//import AuthService from '../../src/services/auth.service.js'
import { mapGetters, mapState } from 'vuex'
import countries from '../countries'
import trendingNews from './trendingNews'
import observationPost from './observationPost'
import pastLives from './pastLives'
import { apiUrl } from '../config'
import profilePage from './profilePage'
import leftMenu from './leftMenu'
import rightMenu from './rightMenu'
import donationForm from './donationForm'

export default {
  directives: {
    ClickOutside,
  },
  data: () => ({
    search: '',
    searchActive: false,  
    openLeftDrawer: false,
    openRightDrawer: false,
    API_URL: apiUrl,
    form: "",
    arrayEvents: null,
    date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    showTrendingNews: false,
    progressBarValue: 0,
    showProgressBar: false,
    uploadedFiles: null,
    uploadedText: "",
    uploadedLink: "",
    uploadLocation: "",
    isDisabled: true,
    dialog: "",
    sheet: "",
    message4: "",
    countries: [],
    profile_image: '',
    profileData: [""],
    openPostDialog: false,
    //feedback message fields
    openFeedback: false,
    openDonation: false,
    feedbackMessage: "",
    error: null,
    success: null,
    username: "",
    feedbackSnackbarMessage: "Your feedback was sent successfully.",
    timeout: 5000,
    showSnackbar: false,
    isMobile: true,  // detect mobile however you like
    items: [
      {
        color: 'blue darken-3',
        src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
        title: 'Haiti Recovery Fund(Placeholder)',
        description: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.',
        keyword: 'Support Mission',
      },
    ],
    // Third list - Chats
    //
    recent: [
      {
        active: true,
        avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
        title: 'Jason Oner',
      },
      {
        active: true,
        avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
        title: 'Mike Carlson',
      },
      {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
        title: 'Cindy Baker',
      },
      {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
        title: 'Ali Connors',
      },
    ],
    previous: [
      {
        title: 'Travis Howard',
        avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
      },
    ],
    search: '',
  }),
  drawer: true,
  mini: true,
  expand: false,
  methods: {
    openMyProfile() {
      let user = localStorage.getItem('user');
      user = JSON.parse(user);

      const token = user.access;

      const payload = JSON.parse(atob(token.split('.')[1]));

      const userId = payload.user_id;

      if (!userId) {
        console.error('User ID is missing')
        return
      }

      this.$emit('open-profile', userId)
    },
    async submitFeedback(formData) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        this.error = null;
        this.success = null;
        const response = await axios.post(
          `${this.API_URL}feedback/`, formData,
          { 
            headers: { 'Authorization': authToken, 
              'Content-Type': 'multipart/form-data',
            } 
          }
        );
        console.log('API Response:', response);

        // Check if the status code is 201 (Created)
        if (response.status === 201) {
          this.showSnackbar = true;
          this.openFeedback = false;
          this.$refs.form.reset();
          return true; // Success
        } else {
          console.error('Unexpected status code:', response.status);
          return false; // Not successful
        }
      } catch (error) {
        console.error('Error creating feedback:', error);
        return false; // Failure
      }
    },
    //Handle Feedback upload
    async handleFeedbackUpload() {

      this.isLoading = true
      const feedbackIdeaData = {
        feedbackMessage: this.feedbackMessage,
      };

      console.log('feedback data from feedbackform', feedbackIdeaData);

      const formData = new FormData();
      formData.append('message', this.feedbackMessage);
    
      this.isLoading = false
    },
    triggerTrendingNews() {
      this.$emit('fetchTrendingNews');
    },
    //Menu functionality
    toggleleftMenu() {
      return this.openLeftDrawer = !this.openLeftDrawer
    },
    toggleRightMenu() {
      return this.openRightDrawer = !this.openRightDrawer
    },
    async getProfileData() {
      try {
        // fetch profile
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken)

        const response = await axios.get(`${this.API_URL}users/current-user/`, {
          headers: {
            'Authorization': authToken,
          },
        })
        // set the data returned as profile
        this.profileData = response.data;
        this.profile_image = this.profileData?.profile.profile_image;
        console.log(this.profileData);

      } catch (error) {
        // log the error
        console.log(error);
      }
    },
    togglePastLives() { },
    toggleDonationForm() { 
      return this.openDonation = !this.openDonation
    },
    reserve() { },
    handleUploadProgressBar() {
      setInterval(() => {
        if (this.progressBarValue === 100) {
          this.showProgressBar = false;
          this.progressBarValue = 0;
          return;
        }
        this.progressBarValue += 20;
        //console.log(progressBarValue);
      }, 1000);
    },
    async createPost(formData) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken);

        const response = await axios.post(`${this.API_URL}posts/`, formData, {
          headers: {
            'Authorization': authToken,
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('API Response:', response);

        // Check if the status code is 201 (Created)
        if (response.status === 201) {
          return true; // Success
        } else {
          console.error('Unexpected status code:', response.status);
          return false; // Not successful
        }
      } catch (error) {
        console.error('Error creating business idea:', error);
        return false; // Failure
      }
    },

    //handle upload method
    async handleUpload() {
      if (this.uploadLocation && this.uploadedText || this.uploadedLink || this.uploadedFiles) {

        const postData = {
          content: this.uploadedText,
          link: this.uploadedLink,
          location: this.uploadLocation.name,
          files: this.uploadedFiles
        }

        console.log('postdata from navbar', postData)

        const formData = new FormData();
        formData.append('content', this.uploadedText);
        formData.append('link', this.uploadedLink);
        formData.append('location', this.uploadLocation.name);
        if (this.uploadedFiles !== null) {
          formData.append('files', this.uploadedFiles);

        }

        const isSuccess = await this.createPost(formData)

        if (isSuccess) {

          this.$emit('fetch-posts')
        }

        // this.$store.dispatch('auth/post', formData).then(() => {
        //   // ... handle any further logic or UI updates
        //   this.$success('Post added successfully!');
        // }).catch(error => {
        //   // ... handle error condition
        //   console.log(error)
        //   this.$error(error)
        // });
      }
    },
    handleUploadLocation(country) {
      this.uploadLocation = country;
    },
    getCountry(country) {
      this.$emit('country', country)
        this.$nextTick(() => {
        this.search = null;
      });
    },
    toggleTrendingNews() {
      this.showTrendingNews = !this.showTrendingNews;
    },
    ...mapMutations({
      setDialog: 'setDialog'
    }),
    showChat() {
      this.setDialog(true)
    },
  },
  watch: {
    isMobile(val) {
      if (val) {
        // On mobile
        this.openLeftDrawer = false;  // start closed
        this.openRightDrawer = false; // start closed
      } else {
        // On desktop
        this.openLeftDrawer = true;   // open by default
        this.openRightDrawer = true; // still closed
      }
    },
  },
  created() {
    this.getProfileData();
  },
  mounted() {
     // Initialize when page loads
    this.openLeftDrawer = !this.isMobile;
    this.openRightDrawer = !this.isMobile;
    this.countries = countries
    this.arrayEvents = [...Array(6)].map(() => {
      const day = Math.floor(Math.random() * 30)
      const d = new Date()
      d.setDate(day)
      return d.toISOString().substr(0, 10)
    })
  },
  components: {
    trendingNews,
    pastLives,
    profilePage,
    leftMenu,
    rightMenu,
    observationPost,
    donationForm,
  },
  watch: {
    message(logMessage) {
      console.log('Name:', logMessage)
    },
    location(logMessage) {
      console.log('Locaion:', logMessage)
    },
    link(logMessage) {
      console.log('Link:', logMessage)
    },
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 600;
        case 'sm': return 600;
        case 'md': return 69;
        case 'lg': return 69;
        case 'xl': return 69;
        default: return 190;
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapState(['user']),
    ...mapGetters({ user: "auth/user" }, { token: "auth/user" }),
    keywords() {
      if (!this.search) return []
      
      const keywords = []

      for (const search of this.searching) {
        keywords.push(search.keyword)
      }

      return keywords
    },
    searching() {
      if (!this.search) return this.items

      const search = this.search.toLowerCase()

      return this.items.filter(item => {
        const text = item.title.toLowerCase()

        return text.indexOf(search) > -1
      })
    },
  },
  props: {
    trendingNews: Array,
    value: { type: Boolean, default: false }, // <- parent will drive this
    isMobile: Boolean
  }
}
</script>